module.exports = __webpack_public_path__ + "static/media/Instagram.159cf941.svg";